/* eslint-disable no-process-env */
import {Configuration} from './types';

/**
 * @todo: move to configuration
 */
const APPLICATION_ID = '580111';
/**
 * @todo: move to configuration
 */
const GRAPHQL_ENDPOINT = `/api/unstable/graphql.json`;

const SHOP_PROMISE_WEBSITE_URL = 'https://shop.app/shop-promise';

export const BWP_SCRIPT_URL_PROD =
  'https://cdn.shopify.com/shopifycloud/optimus-pdp/optimus.js';

let configuration: Configuration | null = null;

export function getConfiguration() {
  if (configuration) {
    return configuration;
  }

  configuration = {
    uxVersion: 'v3',
    applicationId: APPLICATION_ID,
    graphQLEndpoint: GRAPHQL_ENDPOINT,
    shopPromiseWebsiteUrl: SHOP_PROMISE_WEBSITE_URL,
    bugsnagAPIKey: process.env.BUGSNAG_API_KEY || '',
    releaseStage: process.env.RELEASE_STAGE || 'development',
    appVersion: process.env.BUILD_NUMBER || 'no-version',
    optimusPdpUrl:
      process.env.RELEASE_STAGE === 'production'
        ? BWP_SCRIPT_URL_PROD
        : `https://optimus-pdp.${process.env.SPIN_FQDN}/dist/optimus.js`,
  };

  return configuration;
}
